import React from 'react';
import { ExternalLink, Sparkles } from 'lucide-react';
import { partners } from '../data/mock';

export const Partners = () => {
  return (
    <section className="py-24 bg-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 left-1/3 w-96 h-96 bg-purple-600 rounded-full filter blur-3xl"></div>
        <div className="absolute top-1/2 right-1/3 w-96 h-96 bg-pink-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Sparkles className="text-purple-400" size={32} />
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              Våra <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Samarbeten</span>
            </h2>
            <Sparkles className="text-pink-400" size={32} />
          </div>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Vi samarbetar med ledande aktörer i branschen för att erbjuda dig de bästa lösningarna
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {partners.map((partner) => (
            <div 
              key={partner.id}
              className="group bg-gradient-to-br from-gray-800/60 to-gray-900/60 backdrop-blur-sm p-8 rounded-3xl border-2 border-gray-700/50 hover:border-purple-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-purple-500/30 relative"
            >
              <div className="flex flex-col items-center text-center gap-6">
                {/* Logo */}
                <div className="w-full max-w-xs">
                  <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 flex items-center justify-center border border-gray-700/30 group-hover:border-purple-500/30 transition-all duration-300 group-hover:scale-105 h-40">
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-purple-400 group-hover:to-pink-400 transition-all duration-300">
                    {partner.name}
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed mb-6">
                    {partner.description}
                  </p>
                  
                  {partner.website && (
                    <a 
                      href={partner.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-purple-400 hover:text-pink-400 font-semibold transition-colors duration-300"
                    >
                      <span>Besök {partner.id === 2 ? 'Bilnyckelakuten' : partner.name}</span>
                      <ExternalLink size={18} />
                    </a>
                  )}
                </div>
              </div>

              {/* Hover Accent */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-3xl"></div>
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-purple-600/10 to-pink-600/10 backdrop-blur-sm px-8 py-4 rounded-full border border-purple-500/30">
            <p className="text-gray-300 text-lg font-semibold">
              🤝 Vi väljer våra partners med omsorg för att garantera högsta kvalitet
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
